<template>
  <div class="form-group">
    <div class="form__title"><b>Customise the appearance of the {{customiseType}} <br> within the overview</b> (Optional)</div>
    <ColorPicker
      @input="updateBackground"
      :value="backgroundColour"
      :label="`${customiseType} Colour`"
    />
    <ImageUpload
      @imageUploaded="newImageUploaded"
      @remove="imageRemoved"
      variant="small"
      :imageURL="backgroundImage"
      imageType="roomImage"
      previewType="full"
    >
      <template #header> Add optional cover image </template>
      <template #body> 800x800px </template>
    </ImageUpload>

    <div class="toggles">
      <Toggle :label="`${customiseType} name`" offText="Hide" onText="Show" width="80px" :value="showName" @input="updateShowName"/>
      <ToggleOptions v-if="hasBackgroundImage" label="Text colour" :options="textColorOptions" :value="textColor" @input="updateTextColour"/>
    </div>
    <hr>
    <UpdateRoomAngle :startVal="startAngle" :update="updateAngle" :isCreate="isCreate" :customiseType="customiseType" />
  </div>
</template>

<script>
import { Toggle, ToggleOptions } from "@/framework"
import ColorPicker from '@/components/admin/ColorPicker';
import ImageUpload from '@/components/admin/ImageUpload';
import { roomTextColorOptions } from "@/data.js"
import UpdateRoomAngle from './UpdateRoomAngle.vue'


export default {
  name: 'CustomiseSection',
  components: { ColorPicker, ImageUpload, Toggle, ToggleOptions, UpdateRoomAngle },
  props: {
    isCreate: {type: Boolean, default: false},
    customiseType: {type: String, default: 'Room'},
    startAngle: {type: Number, required: false},
    updateAngle: Function,
    backgroundColour: { type: String, default: '' },
    updateBackground: Function,
    backgroundImage: { type: String, default: ''},
    newImageUploaded: Function,
    imageRemoved: Function,
    showName: { type: Boolean, default: true },
    updateShowName: Function,
    textColor: { type: String, default: '' },
    updateTextColour: Function
  },
  computed: {
    textColorOptions: () => roomTextColorOptions,
    hasBackgroundImage() {
      return !!this.backgroundImage
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
hr {
  border: 1px solid $grey-3 !important;
  width: 100%;
  opacity: 0.5;
}
.toggles {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    gap: 30px;

    @include mobile-only {
        flex-direction: column;
        gap: 0;
    }
}

@import "~@/scss/components/modals/modal_forms.scss";
@import '~@/scss/components/modals/create_room_form.scss';
</style>
